/* eslint-disable max-lines-per-function */
import React from 'react';
import { Wrapper } from '@catalogo/theme-wrapper';
import ProductMainArea from '@catalogo/ui-americanas-desktop-product-main-area';
import BlackboxPosition from '@catalogo/core-blackbox/position';
import { getIn } from 'seamless-immutable';
import QnA from '@catalogo/ui-americanas-desktop-qna/src/components/template/TemplateQnA';
import Suggestions from '@catalogo/ui-americanas-desktop-suggestions';
import Reviews from '@catalogo/ui-americanas-desktop-product-review';
import Carousel from '@catalogo/ui-americanas-desktop-carousel';
import ProductInfoAccordion from '@catalogo/ui-americanas-desktop-product-info';
import ProductSpecs from '@catalogo/ui-americanas-desktop-product-specs';
import withProductPage from '@catalogo/service-americanas-product/src/hocs/product-page';
import Schema from '@catalogo/template-americanas-mobile-product/src/schema';
import { FullPageLoading } from '@catalogo/ui-americanas-mobile-loading';
import Error from '@catalogo/template-americanas-mobile-error';
import { Redirect } from '@catalogo/core-redirect';
import BottomAds from '@catalogo/template-americanas-mobile-product/src/components/bottom-ads';
import ReportLink from './components/report-link';

export const ProductTemplate = ({
  product,
  breadcrumb,
  page,
  components,
  parsedQs,
  reviewsQueries,
  productId,
  history,
  currentSku,
  routeId,
  status,
  refetch,
}) => {
  if (status === 'loading') {
    return <FullPageLoading />;
  }

  if (status === 'error') {
    return <Error retry={() => refetch()} />;
  }

  if (status === 'notFound') {
    return <Redirect status={302} url="/" />;
  }

  const templateComponents = getIn(page, ['template', 'top'], []);
  const defaultSearchSuggestions = page?.searchSuggestions;

  return (
    <Wrapper className="Product" color="#f1f1f1">
      <Schema currentSku={currentSku} product={product} page={page} reviewsQueries={reviewsQueries} />
      <BlackboxPosition position="produto-top" publication={getIn(components, ['produto-top'])} />
      <ProductMainArea
        currentSku={currentSku}
        recData={components}
        breadcrumb={breadcrumb}
        product={product}
        page={page}
        parsedQs={parsedQs}
        id={productId}
        history={history}
        routeId={routeId}
      />
      <Carousel position="item_page.rr1" publication={getIn(components, ['item_page.rr1'])} />
      <Carousel position="item_page.ads" publication={getIn(components, ['item_page.ads'])} />
      <Carousel
        position="item_page.rr2"
        publication={getIn(components, ['item_page.rr2'])}
        placeholderForced={!!templateComponents.find(({ id }) => id === 'item_page.rr2')}
      />
      <ProductInfoAccordion
        publication={components?.['produto-descricao']}
        description={product?.['description']}
        categories={product?.['categories'] ?? []}
        page={page}
      />
      <ProductSpecs product={product} />
      <ReportLink id={productId} />
      <Reviews
        productId={productId}
        history={history}
        reviewsQueries={reviewsQueries}
        breadcrumb={breadcrumb}
        productName={product?.name}
      />
      <QnA product={product} breadcrumb={breadcrumb} components={components} currentSku={currentSku} />
      <BlackboxPosition publication={getIn(components, ['item_page.rr3'])} />
      <BlackboxPosition publication={getIn(components, ['item_page.history'])} />
      <BottomAds position="produto-bottom" publication={getIn(components, ['produto-bottom'])} />
      <BlackboxPosition position="schema" publication={getIn(components, ['schema'])} />
      <Suggestions defaultSearchSuggestions={defaultSearchSuggestions} />
    </Wrapper>
  );
};

export default withProductPage(ProductTemplate);
